import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const GetOpportunities = createAsyncThunk(
    'marketplace/getOpportunities',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/MarketplaceOpportunities`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch opportunities');
            }

            return {
                opportunities: response.data,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching opportunities.',
                'error'
            );
            throw error;
        }
    }
);
